import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { ResponseViewerProps, LeadOutcome } from '../../../../../types/testVendorRequest.types';

const smallOpacityStyle: React.CSSProperties = { fontSize: '0.75rem', opacity: 0.8 };

const formatOutcome = (outcome: LeadOutcome | undefined | null): string | null => {
  if (!outcome) return null;

  const rawEntries: Array<[string, string | number | undefined]> = [
    ['result', outcome?.result],
    ['reason', outcome?.reason],
    ['handler', outcome?.handler],
    ['leadId', outcome.leadId != null ? String(outcome.leadId) : undefined],
  ];

  const entries = rawEntries.filter((entry): entry is [string, string | number] => entry[1] != null && entry[1] !== '');

  if (!entries.length) return null;

  return entries.map(([key, val]) => `${key}: ${val}`).join(',\n');
};

const ResponseViewer: React.FC<ResponseViewerProps> = ({ response }) => {
  if (!response) return null;
  const { status, rawBody, outcome } = response;
  const formattedOutcome = formatOutcome(outcome);

  return (
    <div style={{ marginTop: 12 }}>
      <Typography variant='subtitle2' component='h6'>
        Response
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 3 }}>
          <div>
            <div style={smallOpacityStyle}>HTTP Status</div>
            <div data-testid='resp-status' style={{ fontWeight: 600 }}>
              {status}
            </div>
          </div>
        </Grid>
        <Grid size={{ xs: 12, lg: 9 }}>
          <div style={smallOpacityStyle}>Advertiser Response (raw)</div>
          <pre data-testid='resp-raw' style={{ whiteSpace: 'pre-wrap' }}>
            {rawBody}
          </pre>
        </Grid>
      </Grid>
      <div style={smallOpacityStyle}>Lead Outcome</div>
      <pre data-testid='resp-outcome'>{formattedOutcome}</pre>
    </div>
  );
};

export default ResponseViewer;
